import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class ConfigurationService {
  private baseUrl = environment.baseUrl + environment.baseApi;

  constructor(
    private readonly http: HttpClient,
  ) {}

  public async getLastLgpd(url: string): Promise<ILgpdDoc> {
    const token: string = localStorage.getItem('token');

    const headers = new HttpHeaders({ Authorization: `Bearer  ${token}` });

    const request = new HttpRequest<any>('GET', this.baseUrl + url, null, {
      reportProgress: true,
      headers: headers,
    });
    await this.http
      .request(request)
      .toPromise()
      .then((res) => {
        if (res instanceof HttpResponse) {
          response = res.body as ILgpdDoc;
        }
      })
      .catch((e) =>{
       
      });

        console.log(request);

        let response: any;

		await this.http.request(request).toPromise()
        .then(res=>{
            if (res instanceof HttpResponse) {
                response = res.body as ILgpdDoc;
            }
        }).catch(e=>console.log(e));
		
		return response
	}

	public async getLastAcceptanceTerm(url: string, noAuth: boolean = false): Promise<IAcceptanceTerm> {
		const token: string = localStorage.getItem('token');
		const headers = !noAuth ? new HttpHeaders({ Authorization: `Bearer  ${token}` }) : null;
		const request = new HttpRequest<any>('GET', this.baseUrl + url, null, { reportProgress: true, headers: headers });

		let response: IAcceptanceTerm;
		await this.http.request(request).toPromise().then(res => {
			if (res instanceof HttpResponse)
				response = res.body as IAcceptanceTerm;
		}).catch(e => console.log(e));

		return response;
	}

  public async getLogo(url: string, noAuth: boolean = false, params?: HttpParams): Promise<ILogo> {
		const token: string = localStorage.getItem('token');
		const headers = !noAuth ? new HttpHeaders({ Authorization: `Bearer  ${token}` }) : null;
		const request = new HttpRequest<any>('GET', this.baseUrl + url, null, { reportProgress: true, headers: headers, params: params });

		let response: ILogo;
		await this.http.request(request).toPromise().then(res => {
			if (res instanceof HttpResponse)
				response = res.body as ILogo;
		}).catch(e => console.log(e));

		return response;
	}

  public async getColors(url: string, noAuth: boolean = false, params?: HttpParams): Promise<Array<IColor>> {
		const token: string = localStorage.getItem('token');
		const headers = !noAuth ? new HttpHeaders({ Authorization: `Bearer  ${token}` }) : null;
		const request = new HttpRequest<any>('GET', this.baseUrl + url, null, { reportProgress: true, headers: headers, params: params });

		let response: Array<IColor>;
		await this.http.request(request).toPromise().then(res => {
			if (res instanceof HttpResponse)
				response = res.body as Array<IColor>;
		}).catch(e => console.log(e));

		return response;
	}

	public async getHoursToResendNotification(url: string, noAuth: boolean = false): Promise<IResendNotification> {
		const token: string = localStorage.getItem('token');
		const headers = !noAuth ? new HttpHeaders({ Authorization: `Bearer  ${token}` }) : null;
		const request = new HttpRequest<any>('GET', this.baseUrl + url, null, { reportProgress: true, headers: headers });

		let response: IResendNotification;
		await this.http.request(request).toPromise().then(res => {
			if (res instanceof HttpResponse)
				response = res.body as IResendNotification;
		}).catch(e => console.log(e));

		return response;
	}

  public async getLastManual(url: string, noAuth: boolean = false): Promise<IManual> {
		const token: string = localStorage.getItem('token');
		const headers = !noAuth ? new HttpHeaders({ Authorization: `Bearer  ${token}` }) : null;
		const request = new HttpRequest<any>('GET', this.baseUrl + url, null, { reportProgress: true, headers: headers });

		let response: IManual;
		await this.http.request(request).toPromise().then(res => {
			if (res instanceof HttpResponse)
				response = res.body as IManual;
		}).catch(e => console.log(e));

		return response;
	}
}

export interface ILgpdDoc {
  id: string;
  createdAt: number;
  updatedAt: number;
  description: string;
  type: number;
  attachment: IAttach;
}

export interface ILgpdExpirationDoc {
  id: string;
  createdAt: number;
  updatedAt: number;
  daysToExpire: number;
}

export interface IAcceptanceTerm {
	id: string;
	createdAt:number;
	updatedAt: number;
	description: string;
	type: number;
	attachment: IAttach;
}

export interface IAttach {
  attachmentId: string;
  description: string;
}

export interface IResendNotification{
  id:string;
  hours:number;
  createdAt:number;
  updatedAt:number;
  userId:string;
}

export interface IManual {
	id: string;
	createdAt:number;
	updatedAt: number;
	description: string;
	type: number;
	attachment: IAttach;
}

export interface ILogo {
	id: string;
	createdAt:number;
	updatedAt: number;
	description: string;
	type: string;
	attachment: IAttach;
}

export interface IColor {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	code: string;
	type: string;
	attachment: IAttach;
}